import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';

import { AuditService } from '@services/audit.service';

import { set } from 'lodash-es';

const TAG = 'TaInstructionComponent';

@Component({
    selector: 'app-ta-instruction',
    templateUrl: 'ta-instruction.html',
    styleUrls: ['ta-instruction.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TaInstructionComponent extends FieldType implements OnInit {

    public isDebug = false;
    public disableButton = false;
    private updatedKey: string;

    constructor(
        private auditService: AuditService,
    ) {
        super();
    }

    ngOnInit() {
        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }

        if (this.formControl.value === true) {
            this.disableButton = true;
        }
    }

    public async onUnderstoodClick() {
        try {
            this.disableButton = true;
            set(this.model, this.key, true);
            const formControl = this.formControl as FormControl;
            formControl.setValue(true);
            this.auditService.setLocationAndTimestamp(this.updatedKey);
        } catch (error) {
            console.log(TAG, 'onUnderstoodClick(): error=', error);
        }
    }

}
